/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: aeeb275c (Fri Jul 31 21:53:12 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface BulkReassignTeamMemberRequestBody
 */
export interface BulkReassignTeamMemberRequestBody {
  /**
   * Unique identifier for the actor record to reassign all the actors to.
   * @type number
   * @memberof BulkReassignTeamMemberRequestBody
   */
  newSupervisorActorKey: number
  /**
   * The list of actor keys to reassign to report to the newSupervisorActorKey.
   * @type {Array<number>}
   * @memberof BulkReassignTeamMemberRequestBody
   */
  actorKeysToReassign: Array<number>
}

export function BulkReassignTeamMemberRequestBodyFromJSON(
  json: any
): BulkReassignTeamMemberRequestBody {
  return BulkReassignTeamMemberRequestBodyFromJSONTyped(json, false)
}

export function BulkReassignTeamMemberRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BulkReassignTeamMemberRequestBody {
  if (json === undefined || json === null) {
    return json
  }
  return {
    newSupervisorActorKey: json['newSupervisorActorKey'],
    actorKeysToReassign: json['actorKeysToReassign'],
  }
}

export function BulkReassignTeamMemberRequestBodyToJSON(
  value?: BulkReassignTeamMemberRequestBody | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    newSupervisorActorKey: value.newSupervisorActorKey,
    actorKeysToReassign: value.actorKeysToReassign,
  }
}
